export default __webpack_public_path__ + "static/media/photo--sm--wheel-5.0be7688c.jpg";